import {
  ActionFragment,
  SuspiciousCardTxnDetailsTileFragment,
  SuspiciousCardTxnQuestionActionTileFragment,
  SuspiciousCardTxnQuestionTileFragment,
} from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const GetSuspiciousCardTransactionDetails = gql`
  query GetSuspiciousCardTransactionDetails(
    $input: SuspiciousCardTxnTileInput!
  ) {
    suspiciousCardTxnTile(input: $input) {
      ... on SuspiciousCardTxnTile {
        id
        title
        message
        ctaAction {
          ...ActionFragment
        }
        tiles {
          ...SuspiciousCardTxnDetailsTileFragment
          ...SuspiciousCardTxnQuestionTileFragment
          ...SuspiciousCardTxnQuestionActionTileFragment
        }
      }
    }
  }
  ${ActionFragment}
  ${SuspiciousCardTxnDetailsTileFragment}
  ${SuspiciousCardTxnQuestionTileFragment}
  ${SuspiciousCardTxnQuestionActionTileFragment}
`;

export default GetSuspiciousCardTransactionDetails;
